import { isPerpInstrument } from '@/features/hedge/lib/instrument-display'
import { Instrument, InstrumentKind } from '@/types/generated/common/types'

export type InstrumentTabType = 'spot' | 'future' | 'perps' | 'options'

/**
 * Which watchlist tab type an instrument opens as. `perps` is not an instrument kind
 * — a perpetual is a FUTURE with no expiry — so it is separated out by
 * `isPerpInstrument` rather than read off `kind`.
 *
 * Shared by every call site that turns an Instrument into `openInstrumentTab` args,
 * so a tab opened from the picker and one opened from an underlying pointer cannot
 * disagree about the same instrument's type.
 */
export function instrumentTabType(instrument: Instrument): InstrumentTabType {
  if (instrument.kind === InstrumentKind.INSTRUMENT_KIND_SPOT) return 'spot'
  if (instrument.kind === InstrumentKind.INSTRUMENT_KIND_OPTION) return 'options'
  return isPerpInstrument(instrument) ? 'perps' : 'future'
}
